<template>
    <renderless-layout>
        <v-container id="integration_index_page" fluid class="tw-p-0">
            <StickyHeader :nav="nav">
                <template #actions>
                    <div class="tw-space-x-3">
                        <AppBtn icon="check" color="white" @click="createIntegration">
                            {{ $t('app.save') }}
                        </AppBtn>
                    </div>
                </template>
            </StickyHeader>
            <FormBase
                ref="integrationform"
                v-model="integration"
            />
        </v-container>
    </renderless-layout>
</template>
<script>
import StickyHeader from '@/components/StickyHeader.vue'
import AppBtn from '@/components/App/AppBtn.vue'
import { mapState } from 'vuex'
import FormBase from '@/views/Admin/Registries/Integrations/FormBase.vue'
import { IntegrationBase } from '@/models/Integration'
export default {
    name: 'IntegrationsCreate',
    components: {StickyHeader,AppBtn, FormBase},
    data: () => ({
        integration: IntegrationBase({}),
    }),
    computed: {
        ...mapState({
            registry: (state) => state.registries.show.data,
        }),
        nav() {
            return [
                {
                    name: this.$t('app.event'),
                    route: { name: 'admin.registries.index' },
                },
                {
                    name: this.registry.label,
                    route: {
                        name: 'admin.registries.show.home',
                        params: { id: this.registry.id },
                    },
                },
                {
                    name: this.$t('admin.home.labels.integrations'),
                    route: {
                        name: 'admin.registries.integrations.index',
                        params: { id: this.registry.id },
                    },
                },
                {
                    name: this.$t('app.create'),
                    route: {},
                },
            ]
        },
    },
    methods: {
        createIntegration() {
            this.$refs.integrationform.submitCreate()
        },
    },
}
</script>